<template>
  <div>
    <social-header v-if='currentEnv' title="提现记录"></social-header>
    <div class="withdraw" v-if="withdrawList.length !== 0">
      <ul class="withdraw-list">
        <li class="withdraw-list-item" v-for="(item,index) in withdrawList" :key="index">
          <div class="withdraw-state">
            <div class="left">提现状态</div>
            <div class="right">{{item.settlementType}}</div>
          </div>
          <div class="withdraw-price">
            <div class="left">提现金额</div>
            <div class="right">{{item.price}}元</div>
          </div>
          <div class="withdraw-to">
            <div class="left">提现至</div>
            <div class="right">{{item.typeName}}</div>
          </div>
          <div class="withdraw-to" v-if="item.typeName=='汽车之家钱包' && item.settlementType=='转账成功' && isWithinLastThreeDays(item.dateStr)">
            <div class="rights">（如需提现到个人银行卡，请在“之家钱包”点击现金余额）</div>
          </div>
          <div class="withdraw-no">
            <div class="left">提现流水号</div>
            <div class="right">{{item.orderId}}</div>
          </div>
          <div class="withdraw-time">
            <div class="left">提现时间</div>
            <div class="right">{{item.dateStr}}</div>
          </div>
          <!-- <div class="withdraw-time">
            <div class="left">关联订单</div>
            <div class="right" @click="showSubsidyForm=true" style="color: rgb(45, 117, 255);">点击查看</div>
          </div> -->
        </li>
      </ul>  
    </div>
    <Empty v-else/>
    <!-- <div class="popups">
      <van-popup
        v-model="showSubsidyForm"
        round
        position="bottom"
        closeable
        :style="{ height: '80%' }"
      >
        <div class="title">
          <h1>关联订单</h1>
        </div>
        <div class="withdraws" v-if="withdrawList.length>0">
          <ul class="withdraw-lists">
            <van-list
              v-model="loadings"
              :finished="finished"
              @load="onLoad"
              :immediate-check="false"
              finished-text="- 已加载全部 -"
              :offset="10"
            >
            <li class="withdraw-list-item" v-for="(item,index) in withdrawList" :key="index">
              <div class="withdraw-state">
                <div class="left">提现状态</div>
                <div class="right">{{item.settlementType}}</div>
              </div>
              <div class="withdraw-price">
                <div class="left">提现金额</div>
                <div class="right">{{item.price}}元</div>
              </div>
              <div class="withdraw-to">
                <div class="left">提现至</div>
                <div class="right">{{item.typeName}}</div>
              </div>
              <div class="withdraw-to" v-if="item.typeName=='汽车之家钱包' && item.settlementType=='转账成功' && isWithinLastThreeDays(item.dateStr)">
                <div class="rights">（如需提现到个人银行卡，请在“之家钱包”点击现金余额）</div>
              </div>
              <div class="withdraw-no">
                <div class="left">提现流水号</div>
                <div class="right">{{item.orderId}}</div>
              </div>
              <div class="withdraw-time">
                <div class="left">提现时间</div>
                <div class="right">{{item.dateStr}}</div>
              </div>
            </li>
          </van-list>
          </ul>
     </div>
     <Empty v-else/>
      </van-popup>
    </div> -->
    <pull-load target-element="withdraw-list" v-bind:bottom-method="loadMoreWithdraw" v-bind:state="loadMoreState"></pull-load>
    <social-dialog title="正在加载" category="tips" v-bind:show="dialogShow"></social-dialog>
  </div>
</template>
<script>
import Empty from '../../components/empty.vue'
import SocialHeader from '../../components/social-header.vue'
import { isWeiXin, isDingDing, changeDocumentTitle } from '../../service/environment'
import PullLoad from '../../components/pull-load.vue'
import SocialDialog from '../../components/social-dialog.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'Withdraw',
  components: {
    Empty,
    SocialHeader,
    SocialDialog,
    PullLoad
  },
  data: function () {
    return {
      dialogShow: false,
      loadMoreState: 0,
      showSubsidyForm:false,
      loadings: false,
      finished: false,
    }
  },
  computed: {
    ...mapGetters({
      withdrawList: 'withdrawList'
    }),
    currentEnv () {
      if (isWeiXin()) {
        return false
      } else if (isDingDing()) {
        return false
      } else {
        return true
      }
    },
    userINFO () {
      return JSON.parse(localStorage.getItem('USER_INFO'))
    },
    type () {
      return this.$route.query.type
    },
    isWithdraw () {
      if (this.withdrawList.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    isWithinLastThreeDays (dateStr) {
      const targetDate = new Date(dateStr); // 将给定时间字符串转换为 Date 对象
      const currentTime = new Date(); // 当前时间
      const diffTime = Math.abs(currentTime - targetDate); // 计算时间差（单位为毫秒）
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // 将时间差转换为天数
      return diffDays <= 3; // 判断时间差是否在三天内
    },
    // 滚动加载更多
    loadMoreWithdraw: function () {
      var current = this
      current.dialogShow = true
      if (this.loadMoreState !== 0) {
        return false
      }
      this.loadMoreState = 1
      if (this.type === 'success') {
        this.$store.dispatch('loadMoreWithdraws', {type: '2', PlatformAgentID: current.userINFO.platformAgentID}).then(function () {
          current.loadMoreState = 0
          if (current.$store.getters.isWithdrawPageEnd) {
            current.loadMoreState = 2
          }
          current.dialogShow = false
        })
      } else {
        this.$store.dispatch('loadMoreWithdraws', {type: '0', PlatformAgentID: current.userINFO.platformAgentID}).then(function () {
          current.loadMoreState = 0
          if (current.$store.getters.isWithdrawPageEnd) {
            current.loadMoreState = 2
          }
          current.dialogShow = false
        })
      }
    },
    // async onLoad() {
    //   this.loadings = true;
    //   console.log('====================================');
    //   console.log(1111);
    //   console.log('====================================');
    //   // 发送带有当前页数的请求
    //   const res = await getCarList({ pageIndex: this.page+1, pageSize: 10 });
    //   const data = res.data.records;

    //   if (data.length === 0) {
    //     this.finished = true; // 数据加载完毕
    //   } else {
    //     // 合并新数据到列表
    //     this.listcar = [...this.listcar, ...data];
    //     this.page++;
    //   }
    //   this.loadings = false; // 结束加载
    // },
  },
  created () {
    changeDocumentTitle('提现记录')
  },
  beforeMount () {
    var current = this
    current.dialogShow = true
    if (this.type === 'success') {
      this.$store.dispatch('getWithdraws', {type: '2', PlatformAgentID: current.userINFO.platformAgentID}).then(function () {
        current.dialogShow = false
      })
    } else {
      this.$store.dispatch('getWithdraws', {type: '0', PlatformAgentID: current.userINFO.platformAgentID}).then(function () {
        current.dialogShow = false
      })
    }
  }
}
</script>
<style scoped>
  .withdraw{
    width: 100%;
    min-height: 100%;
    height: auto;
    position: relative;
  }
  .withdraw-header{
    width: 100%;
    height: 2.5rem;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    margin-bottom: 1.25rem;
  }
  .withdraw-list{
    width: 100%;
    padding: 1.25rem .875rem;
    box-sizing: border-box;
    overflow: auto;
    padding-bottom: 5rem;
  }
  .withdraw-list-item{
    width: 100%;
    margin-bottom: .75rem;
    padding: 1.25rem 1.0625rem;
    background-color: #fff;
    border-radius: .75rem;
    box-sizing: border-box;
  }
  .withdraws{
    width: 100%;
    background-color: rgba(244,243,247,1);
  }
  .withdraw-lists{
    width: 100%;
    padding: 1.25rem .875rem;
    box-sizing: border-box;
    overflow: auto;
    overflow-y: scroll;
    height: calc(80vh - 2.6rem);
  }
  .popups .title h1 {
    text-align: center;
    font-family: "PingFangSC-Medium";
    font-size: 1rem;
    color: #111e36;
    line-height: 1.875rem;
    font-weight: 600;
    margin-top: .625rem;
    line-height: 1.875rem;
    height: 2rem;
  }
  .withdraw-list-item .withdraw-price,
  .withdraw-to,
  .withdraw-no,
  .withdraw-state,
  .withdraw-time{
    display: flex;
    font-size: .875rem;
    height: 1.875rem;
    align-items: center;
    color: #777;
  }
  .withdraw-to .rights{
    width: 100%;
    text-align: right;
    font-size: .73rem;
    color: #777;
  }
  .withdraw-list-item .left{
    color: rgb(17, 30, 54);
    width: 7.5rem;
  }
  .withdraw-list-item .right{
    width: 100%;
    text-align: right;
  }
  .withdraw-list-item .withdraw-price{
    color: rgb(45, 117, 255);
  }
  .withdraw-list-item .withdraw-state{
    color: rgb(255, 122, 45);
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/withdrawList.vue